module.exports = "https://cdn2-fs.clearscore.com/flux/images/5cc77cb9bfd3149fbd021d00215f3cfa.jpg";